import { Typography, Link, CircularProgress } from '@mui/material';
import React, { useState, useRef } from 'react';
import { useNavigate, Link as RouterLink } from "react-router-dom";
import axios from "axios";
import { useLanguage } from '../context/LanguageContext';
import { confirmationResultStore } from "../auth/store";
import { useLocation } from "react-router-dom";
import { useMode } from "../context/modeContext";

const Otp = () => {

  const { t } = useLanguage();

  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [loading, setLoading] = useState(false);

  const inputRefs = useRef([]);

  const navigate = useNavigate();

  const { mode } = useMode();

  console.log(mode);

  const location = useLocation();

  const receivedNumber = location.state?.number;

  const handleChange = (e, index) => {

    const value = e.target.value;

    if (isNaN(value)) return;

    const newOtp = [...otp];

    newOtp[index] = value.slice(-1);

    setOtp(newOtp);
    
    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }

  };

  const handleKeyDown = (e, index) => {

    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }

  };

  const maskPhoneNumber = (number) => {

    if (!number) return "";

    const str = number.toString();

    return str.slice(0, 2) + "xxxx" + str.slice(-4);

  };

  const isOtpComplete = otp.every((digit) => digit !== "");

  const handleSubmit = async () => {

    const finalOtp = otp.join("");

    if (finalOtp.length !== 6) {
      alert("Please enter the complete OTP");
      return;
    }

    try {

      setLoading(true);

      await confirmationResultStore.confirm(finalOtp);

      await axios.post("/api/users", {
        phone: receivedNumber,
        page_state: mode,
      }, {
        timeout: 10000
      });

      navigate("/disclaimer", {
        state: {
          number: receivedNumber,
          page_state: mode
        }
      });

    } catch (err) {

      console.error("OTP error:", err);

      alert("Invalid OTP. Try again.");

    } finally {

      setLoading(false);

    }

  };

  return (

    <>
      <div className='firstScreen'>

        <div className='otpScreen'>

          <Typography variant='h2'>
            {t('verify_details')}
          </Typography>

          <Typography>
            Enter the OTP sent to +91 {maskPhoneNumber(receivedNumber)}
          </Typography>

          <div className='subTitle'>

            <Typography variant='h4'>
              {t('enter_otp')}
            </Typography>

          </div>

          <div className="otp-area">

            {otp.map((data, index) => (

              <input
                key={index}
                type="tel"
                maxLength="1"
                value={data}
                ref={(el) => (inputRefs.current[index] = el)}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
              />

            ))}

          </div>

          <div className='custom-btn'>

            <Link
              component={RouterLink}
              to="/"
              className='back-btn'
              sx={{ marginTop: '30px' }}
            >
              {t('back_btn')}
            </Link>

            <button
              disabled={!isOtpComplete || loading}
              onClick={handleSubmit}
              style={{
                padding: "10px 20px",
                cursor:
                  isOtpComplete && !loading
                    ? "pointer"
                    : "not-allowed",

                opacity:
                  isOtpComplete && !loading
                    ? 1
                    : 0.5,

                minWidth: "160px",
                height: "45px",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px"
              }}
            >

              {loading ? (
                <>
                  <CircularProgress
                    size={20}
                    color="inherit"
                  />
                  Verifying...
                </>
              ) : (
                t('verify_otp_btn')
              )}

            </button>

          </div>

          <div className='back-btn'></div>

        </div>

      </div>
    </>

  );
};

export default Otp;